import Pricing from '@/views/landing-page/Pricing'
import React from 'react'

const pricing = () => {
  return (
    <Pricing/>
  )
}

export default pricing